import CardSection from 'components/common/CardSection';
import React from 'react';
import ApplicationsSummary from './ApplicationsSummary';
import ApplicationsTable from './ApplicationsTable';

const ParentApplications = () => (
  <CardSection title="applications.header">
    <ApplicationsSummary />
    <ApplicationsTable />
  </CardSection>
);

export default ParentApplications;
